var AI_TOOL_KEYWORDS = {
  // Drilling & concrete
  concrete:     ['rotary hammer', 'hammer drill', 'sds', 'concrete drill bit', 'masonry drill'],
  cement:       ['rotary hammer', 'hammer drill', 'sds drill', 'masonry bit'],
  sds:          ['sds drill', 'rotary hammer', 'sds plus', 'sds max'],
  drill:        ['drill', 'hammer drill', 'drill driver', 'impact driver'],
  bore:         ['auger', 'hole saw', 'drill bit', 'step drill'],
  hole:         ['hole saw', 'step drill', 'annular cutter', 'holesaw'],

  // Fastening & driving
  screw:        ['impact driver', 'screwdriver', 'drill driver'],
  nail:         ['nailer', 'nail gun', 'brad nailer', 'framing nailer'],
  fasten:       ['impact driver', 'nailer', 'drill driver'],
  impact:       ['impact wrench', 'impact driver', 'impact gun'],
  wrench:       ['impact wrench', 'torque wrench', 'ratchet wrench'],
  bolt:         ['impact wrench', 'socket set', 'ratchet'],
  torque:       ['torque wrench', 'impact wrench', 'torque screwdriver'],
  socket:       ['impact wrench', 'socket set', 'ratchet'],

  // Cutting
  cut:          ['circular saw', 'angle grinder', 'jigsaw', 'reciprocating saw'],
  saw:          ['circular saw', 'jigsaw', 'reciprocating saw', 'track saw'],
  grind:        ['angle grinder', 'bench grinder', 'grinder disc'],
  tile:         ['angle grinder', 'tile saw', 'diamond blade', 'tile cutter'],
  metal:        ['angle grinder', 'metal cutting disc', 'grinder', 'cut-off tool'],
  pipe:         ['pipe cutter', 'press tool', 'pipe wrench', 'pipe saw'],
  demo:         ['reciprocating saw', 'demolition hammer', 'angle grinder'],

  // Woodworking
  wood:         ['circular saw', 'router', 'sander', 'jigsaw'],
  woodworking:  ['table saw', 'circular saw', 'router', 'planer', 'sander'],
  deck:         ['circular saw', 'impact driver', 'drill driver', 'framing nailer'],
  frame:        ['framing nailer', 'circular saw', 'hammer drill', 'drill driver'],
  timber:       ['circular saw', 'chainsaw', 'planer', 'router'],
  cabinet:      ['router', 'orbital sander', 'circular saw', 'drill driver'],
  furniture:    ['router', 'orbital sander', 'jigsaw', 'drill driver'],

  // Sanding & finishing
  sand:         ['sander', 'orbital sander', 'belt sander', 'random orbital sander'],
  polish:       ['polisher', 'rupes', 'buffer', 'polishing pad'],
  polishing:    ['polisher', 'rupes', 'polishing pad', 'detailing kit'],
  buff:         ['polisher', 'buffer', 'polishing pad', 'compound'],
  detail:       ['rupes', 'polisher', 'detailing', 'microfibre'],
  car:          ['rupes', 'car polisher', 'detailing', 'buffer'],
  paint:        ['sander', 'spray gun', 'paint roller', 'orbital sander'],

  // Demolition
  demolish:     ['demolition hammer', 'jackhammer', 'angle grinder', 'reciprocating saw'],
  demolition:   ['demolition hammer', 'breaker', 'jackhammer', 'reciprocating saw'],
  break:        ['demolition hammer', 'jackhammer', 'tile breaker'],

  // Power generation
  generator:    ['generator', 'inverter generator', 'portable generator'],
  power:        ['generator', 'power station', 'inverter generator'],
  site:         ['generator', 'site box', 'site light', 'worksite equipment'],
  worksite:     ['generator', 'site light', 'extension lead', 'heavy duty'],
  inverter:     ['inverter generator', 'portable generator', 'power station'],

  // Landscaping & outdoor
  tree:         ['chainsaw', 'pruning saw', 'hedge trimmer'],
  chainsaw:     ['chainsaw', 'guide bar', 'chainsaw chain'],
  hedge:        ['hedge trimmer', 'pruning shears', 'cordless hedge trimmer'],
  garden:       ['chainsaw', 'hedge trimmer', 'leaf blower', 'line trimmer'],
  landscape:    ['chainsaw', 'hedge trimmer', 'lawn mower', 'leaf blower'],
  grass:        ['line trimmer', 'lawn mower', 'string trimmer'],

  // Plumbing
  plumb:        ['pipe cutter', 'pipe wrench', 'press tool'],
  plumbing:     ['pipe cutter', 'press tool', 'pipe wrench', 'basin wrench'],
  press:        ['press tool', 'crimping tool', 'press jaws'],

  // Electrical
  electrical:   ['multimeter', 'cable stripper', 'crimping tool'],
  wire:         ['wire stripper', 'cable stripper', 'multimeter'],
  cable:        ['cable stripper', 'cable tray', 'wire stripper'],

  // Lifting & rigging
  lift:         ['chain block', 'lever hoist', 'lifting sling', 'shackle'],
  hoist:        ['chain block', 'lever hoist', 'electric hoist', 'chain hoist'],
  rig:          ['shackle', 'lifting sling', 'chain block', 'snap hook'],

  // Measuring & layout
  measure:      ['laser measure', 'tape measure', 'digital level'],
  level:        ['laser level', 'spirit level', 'line laser', 'self-levelling laser'],
  laser:        ['laser level', 'laser measure', 'cross-line laser'],
  square:       ['combination square', 'speed square', 'framing square'],

  // Storage & organisation
  storage:      ['tool bag', 'tool chest', 'packout', 'tool box'],
  organise:     ['tool bag', 'packout', 'tool organiser'],
  organize:     ['tool bag', 'packout', 'tool organiser'],
  packout:      ['packout', 'modular storage', 'stackable storage'],

  // Safety
  safety:       ['safety glasses', 'ear protection', 'gloves', 'hard hat'],
  protect:      ['safety glasses', 'ear muffs', 'work gloves'],

  // Ladders & access
  ladder:       ['ladder', 'extension ladder', 'step ladder', 'platform ladder'],
  roofing:      ['ladder', 'fall protection', 'safety harness', 'extension ladder'],

  // Welding
  weld:         ['welder', 'mig welder', 'stick welder', 'welding helmet'],
  welding:      ['mig welder', 'tig welder', 'stick welder', 'welding gloves']
};

// Phase 2.6: product type → Shopify product type strings
var AI_PRODUCT_TYPES = {
  'concrete drilling':   ['Rotary Hammer', 'Hammer Drill', 'SDS Drill', 'SDS Plus Drill', 'SDS Max Drill', 'Concrete Drill Bit'],
  'drilling':            ['Drill', 'Drill Driver', 'Hammer Drill', 'Impact Driver', 'Cordless Drill'],
  'sds drilling':        ['SDS Drill', 'Rotary Hammer', 'SDS Plus Drill', 'SDS Max Drill'],
  'cutting':             ['Circular Saw', 'Angle Grinder', 'Jigsaw', 'Reciprocating Saw', 'Track Saw'],
  'saws':                ['Circular Saw', 'Table Saw', 'Miter Saw', 'Jigsaw', 'Reciprocating Saw'],
  'grinding':            ['Angle Grinder', 'Bench Grinder', 'Die Grinder'],
  'woodworking':         ['Table Saw', 'Circular Saw', 'Router', 'Planer', 'Jigsaw', 'Band Saw'],
  'deck building':       ['Circular Saw', 'Impact Driver', 'Drill Driver', 'Framing Nailer'],
  'framing':             ['Framing Nailer', 'Circular Saw', 'Impact Driver'],
  'polishing':           ['Polisher', 'Random Orbital Polisher', 'Car Polisher'],
  'buffing & polishing': ['Polisher', 'Buffer', 'Random Orbital Polisher'],
  'car detailing':       ['Polisher', 'Random Orbital Polisher', 'Detailing Kit'],
  'detailing':           ['Polisher', 'Random Orbital Polisher', 'Detailing Kit'],
  'sanding':             ['Sander', 'Orbital Sander', 'Belt Sander', 'Random Orbital Sander'],
  'impact tools':        ['Impact Wrench', 'Impact Driver', 'Impact Gun'],
  'fastening':           ['Impact Driver', 'Drill Driver', 'Nailer', 'Screwdriver'],
  'generators':          ['Generator', 'Inverter Generator', 'Portable Generator', 'Petrol Generator'],
  'power generation':    ['Generator', 'Inverter Generator', 'Power Station'],
  'worksite equipment':  ['Generator', 'Site Light', 'Extension Lead', 'Site Box'],
  'demolition':          ['Demolition Hammer', 'Rotary Hammer', 'Jackhammer', 'Breaker'],
  'welding':             ['MIG Welder', 'TIG Welder', 'Stick Welder', 'Welder'],
  'welding equipment':   ['MIG Welder', 'TIG Welder', 'Stick Welder', 'Welding Machine'],
  'lifting & rigging':   ['Chain Block', 'Lever Hoist', 'Electric Hoist', 'Chain Hoist'],
  'hoisting':            ['Chain Block', 'Electric Hoist', 'Lever Hoist'],
  'measuring':           ['Laser Level', 'Laser Measure', 'Digital Level', 'Tape Measure'],
  'levelling':           ['Laser Level', 'Spirit Level', 'Self-Levelling Laser'],
  'laser tools':         ['Laser Level', 'Laser Measure', 'Cross-Line Laser'],
  'tool storage':        ['Tool Bag', 'Tool Box', 'Tool Chest', 'Packout', 'Modular Storage'],
  'landscaping':         ['Chainsaw', 'Hedge Trimmer', 'Leaf Blower', 'Line Trimmer'],
  'chainsaws':           ['Chainsaw', 'Petrol Chainsaw', 'Cordless Chainsaw'],
  'plumbing tools':      ['Pipe Cutter', 'Press Tool', 'Pipe Wrench', 'Basin Wrench'],
  'pipe work':           ['Pipe Cutter', 'Press Tool', 'Pipe Wrench'],
  'wrenches':            ['Impact Wrench', 'Torque Wrench', 'Ratchet Wrench', 'Pipe Wrench'],
  'tree work':           ['Chainsaw', 'Pruning Saw', 'Hedge Trimmer'],
  'hole cutting':        ['Hole Saw', 'Annular Cutter', 'Step Drill', 'Holesaw'],
  'ladders':             ['Ladder', 'Extension Ladder', 'Step Ladder', 'Platform Ladder', 'Fibreglass Ladder'],
  'ladder roofing':      ['Ladder', 'Extension Ladder', 'Safety Harness'],
};

// Phase 2.6: intent → collection handles (for collection-match scoring)
var AI_COLLECTIONS = {
  'cordless':            ['cordless-tools', 'cordless-drills', 'battery-tools'],
  'corded':              ['power-tools', 'corded-tools', 'electric-tools'],
  'drilling':            ['drills', 'hammer-drills'],
  'impact tools':        ['impact-drivers', 'impact-wrenches'],
  'cutting':             ['saws', 'circular-saws', 'angle-grinders'],
  'woodworking':         ['woodworking', 'wood-working-tools'],
  'polishing':           ['polishers', 'detailing', 'car-polishers'],
  'generators':          ['generators', 'inverter-generators'],
  'welding':             ['welding', 'welders'],
  'measuring':           ['measuring-tools', 'measuring-and-layout', 'laser-tools'],
  'tool storage':        ['tool-storage', 'storage', 'tool-boxes'],
  'safety':              ['safety', 'safety-equipment', 'ppe'],
  'lifting & rigging':   ['lifting-rigging', 'chain-blocks', 'hoists'],
  'landscaping':         ['outdoor-equipment', 'chainsaws', 'garden-tools'],
  'plumbing tools':      ['plumbing', 'plumbing-tools'],
};

// Phase 2.6: known tool brands for auto-detection and scoring
var AI_BRANDS = [
  'makita', 'milwaukee', 'dewalt', 'bosch', 'metabo',
  'hikoki', 'hi-koki', 'festool', 'unimig', 'husqvarna',
  'rupes', 'ridgid', 'flex', 'kincrome', 'crescent',
  'bahco', 'knipex', 'stanley', 'fluke', 'level5',
  'worx', 'ryobi', 'ozito', 'ingersoll', 'snap-on',
  'paslode', 'bostitch', 'senco', 'fein', 'hilti',
  'ramset', 'megamax', 'cigweld', 'esab', 'hypertherm'
];

// Phase 2.8: trade type → relevant product types
var TRADE_TOOL_MAP = {
  'carpentry':    ['Circular Saw', 'Router', 'Planer', 'Table Saw', 'Jigsaw', 'Orbital Sander', 'Belt Sander', 'Brad Nailer', 'Drill Driver'],
  'electrical':   ['Multimeter', 'Cable Stripper', 'Crimping Tool', 'Wire Stripper', 'Tester', 'Drill Driver', 'Impact Driver'],
  'plumbing':     ['Pipe Cutter', 'Press Tool', 'Hole Saw', 'Pipe Wrench', 'Basin Wrench', 'Drain Cleaner', 'Drill Driver'],
  'landscaping':  ['Chainsaw', 'Hedge Trimmer', 'Leaf Blower', 'Line Trimmer', 'Lawn Mower', 'Pruning Saw'],
  'concreting':   ['Rotary Hammer', 'Demolition Hammer', 'SDS Drill', 'Jackhammer', 'Angle Grinder', 'Concrete Drill Bit'],
  'general':      ['Drill', 'Circular Saw', 'Impact Driver', 'Angle Grinder', 'Spirit Level', 'Tape Measure']
};

var AI_INTENT_LABELS = {
  concrete:     'concrete drilling',
  cement:       'concrete work',
  sds:          'SDS drilling',
  drill:        'drilling',
  bore:         'boring & hole cutting',
  hole:         'hole cutting',
  screw:        'screw driving',
  nail:         'nailers & nail guns',
  fasten:       'fastening',
  impact:       'impact tools',
  wrench:       'wrenches',
  bolt:         'fastening',
  torque:       'torque tools',
  cut:          'cutting',
  saw:          'saws',
  grind:        'grinding',
  tile:         'tile cutting',
  metal:        'metal cutting',
  pipe:         'pipe work',
  wood:         'woodworking',
  woodworking:  'woodworking',
  deck:         'deck building',
  frame:        'framing',
  timber:       'timber work',
  cabinet:      'cabinet making',
  furniture:    'furniture making',
  sand:         'sanding',
  polish:       'polishing',
  polishing:    'polishing',
  buff:         'buffing & polishing',
  detail:       'detailing',
  car:          'car detailing',
  demolish:     'demolition',
  demolition:   'demolition',
  generator:    'generators',
  power:        'power generation',
  site:         'worksite equipment',
  worksite:     'worksite equipment',
  inverter:     'inverter generators',
  tree:         'tree work',
  chainsaw:     'chainsaws',
  hedge:        'hedge trimming',
  garden:       'garden & outdoor',
  landscape:    'landscaping',
  grass:        'lawn care',
  plumb:        'plumbing',
  plumbing:     'plumbing tools',
  electrical:   'electrical work',
  wire:         'wiring',
  lift:         'lifting & rigging',
  hoist:        'hoisting',
  measure:      'measuring',
  level:        'levelling',
  laser:        'laser tools',
  storage:      'tool storage',
  weld:         'welding',
  welding:      'welding equipment',
  ladder:       'ladders',
  roofing:      'ladder roofing'
};
